<div class="page_layout">
  @if(currentUrl !== '/admin'){
  <div class="page_layout__header">
    <app-admin-header />
  </div>

  <div class="page_layout__navigation">
    <app-navigation-admin />
  </div>

  <div class="page_layout__content">
    <router-outlet />
  </div>
  } @else {
  <div class="page_layout__content page_layout__content--2">
    <router-outlet />
  </div>
  }
</div>
